<template>
  <div 
    class="modal fade" 
    :id="id" 
    tabindex="-1" 
    :aria-labelledby="`${id}Label`" 
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" :class="headerClass">
          <h5 class="modal-title" :id="`${id}Label`">
            <i :class="iconClass" class="bi me-2"></i>
            {{ title }}
          </h5>
          <button 
            type="button" 
            class="btn-close" 
            data-bs-dismiss="modal" 
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          {{ message }}
        </div>
        <div class="modal-footer">
          <button 
            type="button" 
            class="btn" 
            :class="buttonClass"
            data-bs-dismiss="modal"
            @click="$emit('confirm')"
          >
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'

export default {
  name: 'BaseModal',
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Alert'
    },
    message: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => ['info', 'warning', 'error', 'success'].includes(value)
    }
  },
  computed: {
    headerClass() {
      const classes = {
        info: 'bg-info text-white',
        warning: 'bg-warning text-dark',
        error: 'bg-danger text-white',
        success: 'bg-success text-white'
      }
      return classes[this.type]
    },
    buttonClass() {
      const classes = {
        info: 'btn-info text-white',
        warning: 'btn-warning text-dark',
        error: 'btn-danger',
        success: 'btn-success'
      }
      return classes[this.type]
    },
    iconClass() {
      const icons = {
        info: 'bi-info-circle',
        warning: 'bi-exclamation-triangle',
        error: 'bi-x-circle',
        success: 'bi-check-circle'
      }
      return icons[this.type]
    }
  },
  data() {
    return {
      modal: null
    }
  },
  mounted() {
    this.modal = new Modal(document.getElementById(this.id))
  },
  methods: {
    show() {
      this.modal.show()
    },
    hide() {
      this.modal.hide()
    }
  }
}
</script> 